import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { DocumentComponent } from "./document/document.component";
import { FlexComponent } from "./flex/flex.component";
import { ToolboxComponent } from "./toolbox.component";

const routes: Routes = [
  { path: "", component: ToolboxComponent },
  { path: "document", component: DocumentComponent },
  { path: "flex", component: FlexComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ToolboxRoutingModule { }
